import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import PhilosophySection from '../components/PhilosophySection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import FirstAppointmentSection from '../components/FirstAppointmentSection';
import PricingSection from '../components/PricingSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import './HomePage.css';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'philosophie', 'about', 'leistungen', 'ersttermin', 'preise', 'kontakt'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="home-page">
      <Seo
        title="Sportphysiotherapie Oliver Bauer | Hornstein & Umgebung"
        description="Sportphysiotherapie Oliver Bauer in Hornstein: evidenzbasierte Rehabilitation, Return to Sport und Prävention. Master in Exercise and Sports Physiotherapy (Escuela Universitaria Real Madrid – Universidad Europea, 2026). Termine für Leobersdorf, Wiener Neustadt, Ebreichsdorf, Neusiedl und Eisenstadt."
        canonical="/"
        image="/og-image.jpg"
      />
      <Navigation activeSection={activeSection} />
      <HeroSection />
      <PhilosophySection />
      <AboutSection />
      <ServicesSection />
      <FirstAppointmentSection />
      <PricingSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
